'use client';
const caseInsensitiveMatch = (a, b)=>{
    return a.toLowerCase().includes(b.toLowerCase());
};

export { caseInsensitiveMatch };
//# sourceMappingURL=caseInsensitiveMatch.js.map
